/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FrenchInputs */

const en_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const fr_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Français`)
};

const de_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Französisch`)
};

const it_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francese`)
};

const ru_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Французский`)
};

const es_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francés`)
};

const zh_cn2_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`法语`)
};

const ja_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フランス語`)
};

const hi_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रेंच`)
};

const pt_pt2_french = /** @type {(inputs: FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francês`)
};

/**
* | output |
* | --- |
* | "Français" |
*
* @param {FrenchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const french = /** @type {((inputs?: FrenchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FrenchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_french(inputs)
	if (locale === "de") return de_french(inputs)
	if (locale === "it") return it_french(inputs)
	if (locale === "ru") return ru_french(inputs)
	if (locale === "es") return es_french(inputs)
	if (locale === "zh-CN") return zh_cn2_french(inputs)
	if (locale === "ja") return ja_french(inputs)
	if (locale === "hi") return hi_french(inputs)
	if (locale === "pt-PT") return pt_pt2_french(inputs)
	return en_french(inputs)
});